<template>
  <div class="game-box">
    <div v-if="timeList.length > 0" class="match-address-box">
      <div v-for="(item, index) in timeList"
        :key="index"
        :class="valData.type === item.type?'address-right font-address-curr':'address-right font-address'"
        @click="switchAddress(item.type)">{{ item.name }}</div>
    </div>
    <div class="match-show-box" v-if="timeList.length > 0">
      <div @click="switchShow(0)" :class="valData.isEnd === 0?'show-curr':'show-nocurr'">全部显示</div>
      <div @click="switchShow(1)" :class="valData.isEnd === 1?'show-curr':'show-nocurr'">未开始</div>
      <div @click="switchShow(2)" :class="valData.isEnd === 2?'show-curr':'show-nocurr'">已结束</div>
    </div>
    <div class="match-address-box" style="text-align: center;margin-top:20px;">
      <a-table :loading="loading" :pagination="false" :expandIcon="expandIcon" :rowKey='record=>record.fieldNum' :columns="columns" :data-source="data">
        <span slot="state" slot-scope="text">
          <a-tag v-if="text === '已结束'" color="#f50">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '检录中'" color="#2db7f5">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '进行中'" color="#87d068">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '未开始'">{{ text }}</a-tag>
        </span>
        <span slot="matchAddr" slot-scope="text">
          {{ text === null ? '未设置地点' : text }}
        </span>
        <span slot="matchTime" slot-scope="text">
          {{ text === null ? '未设置时间' : text }}
        </span>
        <span slot="rankStr" slot-scope="text, record">
          <span v-if="valData.type === 1">第{{ record.smallGroup }}小组-第{{ record.round }}轮</span>
          <span v-else><div style="width:40px;float: left;color:#b80000;">{{ record.fieldNum }}</div>&ensp;&ensp;<div style="width:60px;float: left;">{{ text }}</div></span>
        </span>
        <span slot="result" slot-scope="text, record">
          <span v-if="record.victoryType !== null"><b>{{ record.redScore }} : {{ record.blueScore }}</b></span>
          <span v-if="record.victoryXs === 'SPOTWIN' && record.victoryType !== null">
            {{ record.victoryType === 'BLUE' ? '(0:1)' : '(1:0)' }}
          </span>
          <br/>
          <ResultPkTag :record="record"/>
        </span>
        <a slot="name" slot-scope="text">{{ text }}</a>
        <a slot="addressName" slot-scope="text">{{ text }}场地</a>
        <span slot="data" slot-scope="text, record">
          <div :style="{color: 'rgb(18, 146, 193)', width: record.redName ? '46%' : '76%', float:'left', textAlign: 'right'}">
            <span v-if="record.isTeam === 0 || (record.isTeam === 1 && record.bluePeopleList !== null && record.bluePeopleList.length > 3)">
              <a-avatar shape="square" v-if="record.blueImg" :src="record.blueImg" size="large" icon="user" />
            </span>
            {{ record.blueName }}
            <b style="color:red;" v-if="record.redName">&ensp;<i style="color: rgb(180, 16, 0);">V</i><i style="color: rgb(18, 146, 193);">S</i>&ensp;</b>
          </div>
          <div v-if="record.redName" style="color: rgb(180, 16, 0);width:54%;float:right;text-align: left;">
            <span v-if="record.isTeam === 0 || (record.isTeam === 1 && record.redPeopleList !== null && record.redPeopleList.length > 3)">
              <a-avatar shape="square" v-if="record.redImg" :src="record.redImg" size="large" icon="user" />
            </span>
            {{ record.redName }}
          </div>
        </span>
        <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-card :style="{width: record.redPeopleList ? '49%' : '100%', float:'left'}" v-if="record.bluePeopleList" :title="programVictoryXs.getColor(record.programId).blue + '方选手（单位名称：' + record.blueTeamName + ')'">
            <a-card-grid v-for="(item, index) in record.bluePeopleList" :key="index" style="width:20%;text-align:center">
              <a-avatar shape="square" v-if="item.img" :src="item.img" size="large" icon="user" /><br/>
              {{ item.name }}
            </a-card-grid>
          </a-card>
          <a-card style="width:50%;float:right;" v-if="record.redPeopleList" :title="programVictoryXs.getColor(record.programId).red + '方选手（单位名称：' + record.redTeamName + ')'">
            <a-card-grid v-for="(item, index) in record.redPeopleList" :key="index" style="width:20%;text-align:center">
              <a-avatar shape="square" v-if="item.img" :src="item.img" size="large" icon="user" /><br/>
              {{ item.name }}
            </a-card-grid>
          </a-card>
        </p>
      </a-table>
      <div v-if="isMore">
        <a-button @click="onLoadMore" style="margin: 20px;">
          加载更多
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import programVictoryXs from '@comm/utils/programVictoryXs'
import matchFun from '@comm/utils/matchFun'
import ResultScoreTag from './ResultScoreTag'
import ResultPkTag from './ResultPkTag'
export default {
  name: 'DefaultGame',
  components: {
    ResultScoreTag,
    ResultPkTag
  },
  created () {
    this.findAddress()
  },
  watch: {
    '$route': 'findAddress'
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      isMore: false,
      timeList: [],
      addressList: [],
      valData: {
        matchTime: null,
        addressName: null,
        type: 1,
        matchId: this.$route.query.matchId,
        pageNum: 1,
        pageSize: 10,
        isEnd: 0
      },
      matchFun: matchFun,
      programVictoryXs: programVictoryXs,
      columns: [{
        title: '比赛地点',
        width: '20%',
        dataIndex: 'matchAddr',
        scopedSlots: { customRender: 'matchAddr' }
      },
      {
        title: '比赛时间',
        width: '20%',
        dataIndex: 'matchTime',
        scopedSlots: { customRender: 'matchTime' }
      },
      {
        title: '进程',
        width: '15%',
        dataIndex: 'rankStr',
        scopedSlots: { customRender: 'rankStr' }
      },
      {
        title: '参赛信息',
        align: 'center',
        width: '30%',
        dataIndex: 'data',
        scopedSlots: { customRender: 'data' }
      },
      {
        title: '结果',
        align: 'center',
        width: '15%',
        dataIndex: 'result',
        scopedSlots: { customRender: 'result' }
      }],
      loading: false,
      data: [],
      total: 0
    }
  },
  methods: {
    findAddress () {
      this.$api.battle.matchType({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.timeList = res.data
          if (this.timeList.length > 0) {
            this.valData.type = this.timeList[0].type
            this.findData(false)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findData (bool) {
      this.loading = true
      this.$api.battle.queryBigballPkDatas(this.valData).then(res => {
        this.loading = false
        if (res.status === 0) {
          if (bool) {
            this.data = this.data.concat(res.data)
          } else {
            this.data = res.data
          }
          this.total = res.total
          this.isMore = this.total > this.data.length
        }
      }).catch(err => {
        console.log(err)
      })
    },
    switchAddress (type) {
      this.valData.pageNum = 1
      this.valData.type = type
      this.findData(false)
    },
    switchShow (isEnd) {
      this.valData.pageNum = 1
      this.valData.isEnd = isEnd
      this.findData(false)
    },
    onLoadMore () {
      this.valData.pageNum = this.valData.pageNum + 1
      this.findData(true)
    },
    expandIcon (props) {
      if (props.record.bluePeopleList !== null && props.record.bluePeopleList.length > 0) {
        if (props.expanded) {
          return <a style="color: 'black',margin-right:0px" onClick={e => {
            props.onExpand(props.record, e)
          }}><a-icon type="caret-down" /></a>
        } else {
          return <a style="color: 'black' ,margin-right:0px" onClick={e => {
            props.onExpand(props.record, e)
          }}><a-icon type="caret-right" /></a>
        }
      } else {
        return <span style="margin-right:0px"></span>
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.match-show-box {
  width: 1200px;
  margin: 0 auto;
  height: 30px;
}
.show-curr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #434343;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.show-nocurr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #ccc;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.game-box{
  min-height: 300px;
}
.font-address-curr {
  font-weight: bold;
  font-size: 20px;
  background: #b80000;
  color: #fff;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.address-right {
  float: left;
  margin-right: 22px;
  cursor: pointer;
  margin-bottom: 20px;
}
.font-address {
  font-weight: bold;
  font-size: 20px;
  background: #eeeeee;
  color: #999999;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.match-address-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 20px;;
}
.day-box {
  width: 100px;
  height: 100px;
  float: left;
  cursor: pointer;
}
.match-time-box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  margin-top: 20px;
  position: relative;
  background-image: url(../../assets/dayline.png);
  background-size: 94% 2%;
  background-repeat: no-repeat;
  background-position-y: 39px;
  background-position-x: 36px;
}
.line-left {
  cursor: pointer;
  position: absolute;
  top: 24px;
  left: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 21px;
  border: 1px solid #a0a0a0;
}
.line-right {
  position: absolute;
  top: 24px;
  right: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 21px;
  border-radius: 100%;
  cursor: pointer;
  border: 1px solid #a0a0a0;
}
.day-font {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
.day-font-curr {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #b41000;
  text-align: center;
}
.day-curr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #b41000;
  margin-left: 37px;
  background: white;
}
.day-nocurr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #ccc;
  margin-left: 37px;
  background: white;
}
.chang-font {
  width: 60%;
  height: 25px;
  background: #b41000;
  color: white;
  border-radius: 5px;
  margin-left: 20px;
  margin-top: 7px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/BigGame.vue